import { useEnrollAccountInDomesticContentMutation } from '@/services/accounts';
import { isErrorWithData } from '@/services/helpers';
import { Box, Button, Modal, toast } from '@palmetto/palmetto-components';

export const EnrollDomesticContentModal = ({
  isModalOpen,
  handleCloseModal,
  accountId,
}: {
  isModalOpen: boolean;
  handleCloseModal: () => void;
  accountId: string;
}) => {
  const [enrollInDomesticContent, { isLoading }] = useEnrollAccountInDomesticContentMutation();

  const handleEnroll = async () => {
    try {
      await enrollInDomesticContent({ id: accountId }).unwrap();
      toast.success('Account enrolled in domestic content pricing');
      handleCloseModal();
    } catch (e) {
      if (isErrorWithData(e)) {
        const errorMessage = e.data.message;
        toast.error(`Error enrolling in domestic content: ${errorMessage}`);
      } else {
        console.error(e);
        toast.error('Error enrolling in domestic content');
      }
    }
  };

  const handleDismiss = () => {
    if (!isLoading) {
      handleCloseModal();
    }
  };

  return (
    <Modal ariaLabelledBy="enrollDomesticContentModal" isOpen={isModalOpen} onDismiss={handleDismiss} maxWidth="5xl">
      <Modal.Header id="enrollDomesticContentModal" title="Enroll in Domestic Content" onDismiss={handleDismiss} />
      <Modal.Body childGap="md" background="secondary">
        <Box>
          Are you sure you want to enroll this account in domestic content pricing? This will update the account and
          quote pricing to include the domestic content modifier. The account must meet all domestic content
          requirements at installation to qualify.
        </Box>
      </Modal.Body>
      <Modal.Footer justifyContent="space-between">
        <Button onClick={handleDismiss} variant="secondary" tone="neutral" isDisabled={isLoading}>
          Cancel
        </Button>
        <Button
          variant="primary"
          className="shadow-xs"
          onClick={handleEnroll}
          style={{ whiteSpace: 'nowrap' }}
          isDisabled={isLoading}
          isLoading={isLoading}
        >
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
